import { sql } from 'drizzle-orm';
import { text } from 'drizzle-orm/sqlite-core';

/** { fieldName: `${isoTimestamp}|${mutationId}` } — last-write-wins per field during sync (conventions §14). */
export type FieldClock = Record<string, string>;

/**
 * Columns every synced, user-owned table starts with (conventions §3).
 * A function, not a constant: Drizzle column builders cannot be shared between tables.
 * Timestamps are ISO-8601 UTC strings set by the code that applies a mutation, so no SQL defaults.
 */
export function syncedColumns() {
  return {
    id: text('id').primaryKey(),
    userId: text('user_id').notNull(),
    createdAt: text('created_at').notNull(),
    updatedAt: text('updated_at').notNull(),
    deletedAt: text('deleted_at'),
    clock: text('clock', { mode: 'json' })
      .$type<FieldClock>()
      .notNull()
      .default(sql`'{}'`),
  };
}
